import { useMemo } from 'react';
import type { GroupedCustomization } from './customizationGrouping';
import type { Nullable } from '@synqo/frontend-component-library';

export const useOrderedCustomizations = (customizations: GroupedCustomization[]) =>
    useMemo(() => {
        let main: Nullable<GroupedCustomization> = null;
        let offset: Nullable<GroupedCustomization> = null;
        const others: GroupedCustomization[] = [];

        for (const item of customizations) {
            if ('keyword' in item && item.keyword === null) main = item;
            else if ('control' in item && item.control === 'offset') offset = item;
            else others.push(item);
        }

        return [main, offset, ...others];
    }, [customizations]);
